module.exports = __webpack_public_path__ + "img/BonofInt.d38b788f.png";